export const DELETE_OPTIN_FORMS = `
mutation ArchiveOptInForms($workspaceId: ID!, $optInFormIds: [ID]!) {
  completed: archiveOptInForms(workspaceId: $workspaceId, ids: $optInFormIds)
}
`;
